import React, { useState, useEffect } from 'react';
import { useTable, usePagination } from 'react-table';
import './ApprovalTable.css'; // Your custom CSS for styling

import { useIntl } from '@edx/frontend-platform/i18n';
import messages from '../messages'; // Import the messages file


const ProgramCreationTable = ({
  data,
  page,
  pageSize,
  totalCount,
  setPage,
  setPageSize,
  setSearch,
  selectedRows, // Receive selectedRows from parent
  setSelectedRows, // Receive setSelectedRows from parent
}) => {
  const [searchTerm, setSearchTerm] = useState('');
//  const [selectedRows, setSelectedRows] = useState([]);
const { formatMessage } = useIntl();

  // Debounced search to optimize search performance
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm.length > 2) {
        setSearch(searchTerm);
        setPage(0); // Reset to page 0 when search term changes
      } else if (searchTerm.length === 0) {
        setSearch('');
        setPage(0);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, setSearch, setPage]);

  // Define columns for the table with the original column names and properties
  const columns = React.useMemo(
    () => [
      {
        Header: formatMessage(messages.columnSelect),
        accessor: 'select',
        Cell: ({ row }) => (
          <input
            type="checkbox"
            onChange={() => handleRowSelection(row)}
            checked={selectedRows.includes(row.original.id)}
          />
        ),
      },
      {
        Header: formatMessage(messages.columnID),
        accessor: 'id',
      },
      {
        Header: formatMessage(messages.columnUsername),
        accessor: 'username',
      },
      {
        Header: formatMessage(messages.columnCourseName),
        accessor: 'course',
      },
      {
        Header: formatMessage(messages.columnStatus),
        accessor: 'status',
        Cell: ({ value }) => {
          const statusClass = value;
          return <span className={`status-${statusClass}`}>{value}</span>;
        },
      },
      {
        Header: formatMessage(messages.columnIsActive),
        accessor: 'is_Active',
        Cell: ({ value }) =>
          value ? <span className="active">{formatMessage(messages.active)}</span> : <span className="inactive">{formatMessage(messages.inactive)}</span>,
      },
    ],
    [selectedRows]
  );
  

  // Handle row selection (checkbox logic)
  const handleRowSelection = (row) => {
    console.log(row,'=-------------=');
    if (selectedRows.includes(row.original.id)) {
      setSelectedRows(selectedRows.filter((id) => id !== row.original.id)); // Deselect
    } else {
      setSelectedRows([...selectedRows, row.original.id]); // Select
    }
  };

  console.log(selectedRows,"==-=--=");

  // Table hooks
  const {
    rows,
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize: setTablePageSize,
  } = useTable(
    {
      columns,
      data: data || [],
      initialState: { pageIndex: 0, pageSize: 10 },
      manualPagination: true,
      pageCount: Math.max(Math.ceil((totalCount || 0) / (pageSize || 10)), 1),
    },
    usePagination
  );

  

  // Handle page size changes
  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    setPageSize(newSize);
    setPage(0); // Reset to the first page when size changes
  };

  // Handle search term changes
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Calculate total number of pages
  console.log(totalCount,"=-=")
  const totalPages = Math.max(Math.ceil((totalCount || 0) / (pageSize || 10)), 1);

  console.log(totalPages,pageSize,Math.min(1,totalCount),"toal page");
  const startIndex = page * pageSize + 1;
  const endIndex = Math.min((page + 1) * pageSize, totalCount);
  console.log(startIndex , endIndex ,"index");
  return (
    <div className="table-container">
      {/* Search and page size controls */}
      <div className="second-filter-row">
        <div className="entries-filter">
          <label htmlFor="entries"> {formatMessage(messages.layoutShow)}</label>
          <select
            id="entries"
            name="entries"
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            {(() => {
              const availableSizes = [10, 20, 30, 40, 50];
              let filteredSizes = availableSizes.filter(
                (size) => size <= totalCount
              );

              if (totalCount > Math.max(...filteredSizes) && totalCount < 50) {
                filteredSizes.push(Math.ceil(totalCount / 10) * 10);
              }

              if (totalCount >= 50) {
                filteredSizes = availableSizes;
              }

              return filteredSizes.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ));
            })()}
          </select>
          <span>{formatMessage(messages.layoutEntries)} </span>
        </div>

        <div className="search-box">
          <label htmlFor="search">   {formatMessage(messages.layoutSearch)} :</label>
          <input
            type="text"
            id="search"
            name="search"
            placeholder={formatMessage(messages.layoutSearch)}
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      {/* Table display */}
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} key={column.id}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={row.id}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()} key={cell.column.id}>
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Pagination controls */}
      <div className="pagination-container">
        <div className="footer-info">
        <span>
  {formatMessage(messages.showingEntries, {
    startIndex,
    endIndex,
    totalCount,
  })}
</span>

        </div>
        <div className="pagination-controls">
          <button onClick={() => setPage(Math.max(0, page - 1))} disabled={page === 0}>
            {formatMessage(messages.layoutPrevious)}
          </button>
          {[...Array(totalPages).keys()].slice(Math.max(0, page - 2), Math.min(totalPages, page + 3)).map((pageNumber) => (
            <button
              key={pageNumber}
              onClick={() => setPage(pageNumber)}
              className={page === pageNumber ? 'active' : ''}
            >
              {pageNumber + 1}
            </button>
          ))}
          <button onClick={() => setPage(Math.min(totalPages - 1, page + 1))} disabled={page === totalPages - 1}>
            Next
            {formatMessage(messages.layoutNext)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProgramCreationTable;
